export const CURRENCY_FETCH_SUCCESS = 'CURRENCY_FETCH_SUCCESS';
export const CONFIGURATION_FETCH_SUCCESS = 'CURRENCY_FETCONFIGURATION_FETCH_SUCCESSCH_SUCCESS';
export const LOADER_CONFIG_STOP = 'LOADER_CONFIG_STOP';
export const LOADER_CONFIG_START = 'LOADER_CONFIG_START';
